// components/marketer/MarketerBanner.jsx   (FINAL ORANGE THEME – BEAUTIFUL & PROFESSIONAL)
import { useState } from "react";
import { Users, Building2, DollarSign, Star, ArrowRight } from "lucide-react";
import MarketerSignupModal from "./MarketerSignupModal";
import { FaNairaSign } from "react-icons/fa6";

export default function MarketerBanner() {
  const [isModalOpen, setIsModalOpen] = useState(false);

  return (
    <>
      {/* ORANGE-THEMED BANNER – CLEAN & ATTRACTIVE */}
      <div className="relative bg-gradient-to-br from-orange-500 via-orange-600 to-red-600 text-white overflow-hidden rounded-3xl shadow-2xl mx-4 md:mx-10 my-12">
        <div className="absolute inset-0 bg-black opacity-20"></div>
        
        <div className="relative z-10 p-8 md:p-14 text-center">
          <div className="max-w-4xl mx-auto">
            <h1 className="text-3xl md:text-5xl font-extrabold mb-5 leading-tight">
              How to earn as a <span className="text-yellow-300">Recruiter Marketer</span><br />
              {/* & <span className="text-yellow-300">Earn Big Money!</span> */}
            </h1>
            
            <p className="text-lg md:text-xl mb-8 opacity-95 leading-relaxed">
              Create Job Seekers → Earn <span className="text-green-300 font-bold text-2xl">₦1,000</span> each<br />
              Create Employers → Earn <span className="text-green-300 font-bold text-2xl">₦5,000</span> each
            </p>

            {/* Earnings Cards */}
            <div className="grid grid-cols-1 sm:grid-cols-3 gap-6 mb-10 max-w-3xl mx-auto">
              <div className="bg-white/20 backdrop-blur-lg p-6 rounded-2xl border border-white/30">
                <FaNairaSign className="w-12 h-12 text-green-300 mx-auto mb-3" />
                <p className="text-3xl font-bold">₦1,000</p>
                <p className="text-sm opacity-90">Per Job Seeker</p>
              </div>
              <div className="bg-white/20 backdrop-blur-lg p-6 rounded-2xl border border-white/30">
                <Building2 className="w-12 h-12 text-yellow-300 mx-auto mb-3" />
                <p className="text-3xl font-bold">₦5,000</p>
                <p className="text-sm opacity-90">Per Employer</p>
              </div>
              <div className="bg-white/20 backdrop-blur-lg p-6 rounded-2xl border border-white/30">
                <Star className="w-12 h-12 text-orange-300 mx-auto mb-3" />
                <p className="text-3xl font-bold">30%</p>
                <p className="text-sm opacity-90">Weekly Payout</p>
              </div>
            </div>

            {/* CTA Button */}
            <button
              onClick={() => setIsModalOpen(true)}
              className="bg-white text-orange-600 px-10 py-4 rounded-full font-bold text-xl hover:bg-gray-100 transition shadow-2xl flex items-center gap-3 mx-auto"
            >
              Explore More <ArrowRight className="w-7 h-7" />
            </button>
          </div>
        </div>

        {/* Bottom gradient fade */}
        <div className="absolute bottom-0 left-0 right-0 h-24 bg-gradient-to-t from-black/30 to-transparent"></div>
      </div>

      {/* MODAL */}
      {isModalOpen && <MarketerSignupModal onClose={() => setIsModalOpen(false)} />}
    </>
  );
}